import qs from 'query-string'

import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'
import { ScheduleResponse } from 'models/Schedule'

interface GetScheduleListParams {
  username: string
  profileRole: string
  endDateGte: string
  statusCode: string[]
  sort: string
}

interface GetScheduleListResponse {
  schedules: ScheduleResponse[]
}

export async function getScheduleList({
  username,
  profileRole,
  endDateGte,
  statusCode,
  sort = 'asc'
}: GetScheduleListParams): Promise<ScheduleResponse[]> {
  const params = {
    ...(username && { username }),
    ...(endDateGte && { end_date__gte: endDateGte }),
    ...(profileRole && { profile_role: profileRole }),
    ...(statusCode && { status_code: statusCode }),
    ...(sort && { sort }),
  }

  const { data } = await axios.get<GetScheduleListResponse>(
    apiEndpoints.SCHEDULES,
    { 
      params,
      paramsSerializer: params => {
        return qs.stringify(params)
      },
    },
  )
  
  return data.schedules
}